import { SvgIcon, SvgIconProps } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';
const { PLAIN_ICON } = COLORS;

const AfterHourIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M10 0c3.443 0 6.62 1.778 8.438 4.63V2.46a.781.781 0 1 1 1.562 0v2.306a2.5 2.5 0 0 1-2.5 2.5h-2.385a.781.781 0 1 1 0-1.563h2.148A8.458 8.458 0 0 0 10 1.563c-4.652 0-8.438 3.785-8.438 8.437 0 4.652 3.786 8.438 8.438 8.438h.04c.237 0 .478-.01.714-.03a.78.78 0 1 1 .13 1.557c-.279.023-.563.035-.845.035h-.03a9.938 9.938 0 0 1-7.08-2.929A9.935 9.935 0 0 1 0 10a9.935 9.935 0 0 1 2.929-7.071A9.935 9.935 0 0 1 10 0zm4.146 17.372a.781.781 0 0 1 .762 1.365c-.246.137-.5.265-.757.381a.779.779 0 0 1-1.034-.39.781.781 0 0 1 .39-1.034c.217-.098.432-.206.64-.322zm3.76-2.502a.781.781 0 0 1 .161 1.093 10.07 10.07 0 0 1-.534.658.78.78 0 0 1-1.102.068.781.781 0 0 1-.068-1.103c.157-.178.309-.365.45-.555a.781.781 0 0 1 1.093-.16zM10 2.97c.431 0 .781.35.781.781V10a.781.781 0 0 1-.229.552L7.46 13.646a.779.779 0 0 1-1.105 0 .781.781 0 0 1 0-1.105l2.865-2.865V3.75c0-.431.35-.781.781-.781zm8.284 8.835a.781.781 0 0 1 1.526.332c-.06.275-.132.55-.215.82a.782.782 0 0 1-1.493-.462c.07-.226.131-.458.182-.69z"
        fill={props.htmlColor || PLAIN_ICON}
        fill-rule="nonzero"
      />
    </SvgIcon>
  );
};

export default AfterHourIcon;
